<script setup lang="ts">
import type {BaseMessage, MessageStatus} from "@/conversation/interfaces";
import {TriangleAlert} from "@lucide/vue";
import {computed} from "vue";
import BaseTooltip from "@/core/components/tooltips/BaseTooltip.vue";

const props = defineProps<{
    status: MessageStatus | string;
    hasFailover?: boolean;
    channel: BaseMessage['channel'];
}>();

const config = computed(() => {
    if (props.status === 'read' || (props.channel === 'sms' && ['delivered', 'submitted'].includes(props.status))) {
        return {label: 'Lu', dot: 'bg-green-500', text: 'text-muted-foreground'};
    }

    if (['delivered', 'submitted'].includes(props.status)) {
        return {label: 'Délivré', dot: 'bg-blue-500', text: 'text-muted-foreground'};
    }

    if (['failed', 'rejected', 'undeliverable'].includes(props.status)) {
        return {label: 'Échec', dot: 'bg-red-500', text: 'text-red-600'};
    }

    if (props.status === 'received') {
        return {label: 'Reçu', dot: 'bg-indigo-500', text: 'text-muted-foreground'};
    }

    return {label: props.status, dot: 'bg-slate-400', text: 'text-muted-foreground'};
});
</script>

<template>
  <div class="flex items-center gap-2">
    <span class="flex items-center gap-1.5 whitespace-nowrap text-sm" :class="config.text">
      <span class="size-2 rounded-full shrink-0" :class="config.dot" />
      {{ config.label }}
    </span>
    <div v-if="hasFailover" class="flex">
      <BaseTooltip>
        <TriangleAlert class="w-4 h-4 text-warning" />
        <template #content>
          RCS non supporté - délivré par SMS
        </template>
      </BaseTooltip>
    </div>
  </div>
</template>
